import { gql } from "@apollo/client"
import craftApolloClient from '../../api/apollo'

import { useContext } from "react"
import { GlobalContext } from '../../_app'

import Image from "next/image"


import { Header, HeaderShim } from '../../../fuselage/global/header/header'
import { Footer } from '../../../fuselage/theme/2024/layout/footer/footer'
import { StickySidebar } from '../../../fuselage/layout/sticky-sidebar/sticky-sidebar'
import { ArrowLink } from '../../../fuselage/components/arrow-link/arrow-link'
// import { ButtonSocial } from  '../../../fuselage/components/button-social/button-social'

import CSS from '../../../css/app/speakers.module.css'


export default function Profile ({ profile }) {

    const globals = useContext(GlobalContext)

    // console.log('profile data:', profile)

    return (
        <>
            <Header mainMenu={globals.nodes} />

            <div className="bg-default">

                <section className="block pt-0">
                    <div className="container">

                        <StickySidebar size='medium'>

                            <aside className="formatted">
                                <HeaderShim/>
                                <p className="fw-600"><ArrowLink href="/advisory-board">Advisory Board</ArrowLink></p>
                                <div className={`${CSS.avatar} mt-sm`}>
                                    {
                                        profile.avatar.length ?
                                            <Image className={CSS.photo} src={profile.avatar[0].url} layout='fill' alt="" unoptimized/>
                                        :
                                            <Image className={CSS.photo} src={`/assets/ui/avatar-fallback.png`} layout='fill' alt="" unoptimized/>
                                    }
                                </div>
                            </aside>
                            
                            <main className="maxw-60">
                                <HeaderShim/>
                                <p className='fs-1 fw-600 lh-1 c-primary maxw-40'>Profile</p>
                                <p className="fs-3 fw-600 caps mt-sm">{profile.title}</p>
                                
                                {
                                    profile.positions.map( position => (
                                        <p key={position.id} className='mt-xxs'>
                                            { position.jobTitle }<br/>
                                            <span className="fw-600">{ position.organisation }</span>
                                        </p>
                                    ))
                                }
                                
                                <div className="formatted mt-sm maxw-50" dangerouslySetInnerHTML={{__html: profile.profile }} />
                            </main>

                        </StickySidebar>

                    </div>
                </section>

            
            </div>

            <Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
        </>
    )
}
Profile.theme = 'aviadev-2024'



export async function getStaticPaths() {

    const res = await craftApolloClient().query({
        query: gql`
            query Profiles {
                entries(site: "${process.env.SITE_HANDLE}", section: "profiles") {
                    slug
                }
            }
        `
    })

    const entries = await res.data.entries

    return {
        // paths: entries.map( entry => ({ params: { slug: entry.slug } })),
        // fallback: false
        paths: [],
		fallback: 'blocking',
    }

}

export async function getStaticProps({ params, preview, previewData }) {

    const data = await craftApolloClient( preview, previewData ).query({
        query: gql`
            query Profile {
                entries(site: "${process.env.SITE_HANDLE}" section: "profiles" slug: "${params.slug}") {
                    ... on profiles_profile_Entry {
                        id
                        slug
                        title
                        avatar {
                            ... on avatars_Asset {
                                id
                                url
                                width
                                height
                            }
                        }
                        positions {
                            ... on positions_BlockType {
                                id
                                jobTitle
                                organisation
                            }
                        }
                        profile
                    }
                }
            }
        `
    })

    const profile = data.data.entries[0]

    return { props: { profile }}
}